import { lazy } from 'react';

export const Shop = lazy(() => import(/* webpackChunkName: "shop" */ './shop-container'));
export const ShopV3 = lazy(() => import(/* webpackChunkName: "shop" */ './shop-v3-container'));
